import { render } from "./AddNewCustomerModal.vue?vue&type=template&id=a6ccfab4&ts=true"
import script from "./AddNewCustomerModal.vue?vue&type=script&lang=ts"
export * from "./AddNewCustomerModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__